<template>
  <div class="customer-basic" v-loading="isLoading">
    <!-- <div class="title">必填设置</div> -->
    <el-form label-position="left">
      <div v-for="(item, index) in requiredList" :key="index">
        <div
          class="check-box"
          v-if="
            item.value === true ||
            item.value === false ||
            item.value === 'true' ||
            item.value === 'false'
          "
        >
          <el-checkbox v-model="item.value">{{ item.displayName }}</el-checkbox>
        </div>
        <el-form-item v-else class="auto-height clear">
          <div class="rules-name">{{ item.displayName }}</div>
          <el-input
            v-model="item.value"
            clearable
            :min="0"
            :placeholder="`请输入${item.displayName}`"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="btn-group clear">
      <el-button type="primary" @click="changeClaims" :loading="isLoadingSubmit"
        >保存</el-button
      >
      <el-button @click="reduction" :loading="isCloaseLoading">重置</el-button>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import { customerSettings, updateCustomerSettings } from "@/http/api/system";
export default {
  props: {
    isEdit: { type: Boolean },
  },
  data() {
    return {
      requiredSetting: [],
      requiredList: [],
      isDisabled: false,
      permissions: this.$store.getters.permissions,
      isCloaseLoading: false,
      isLoadingSubmit: false,
      isLoading: true,
    };
  },
  mounted() {
    this.init();
    // this.isDisabled = !this.permissionList["RocketIdentity.Roles.ManagePermissions"];
  },
  methods: {
    reduction() {
      this.isCloaseLoading = true;
      this.init();
      this.isCloaseLoading = false;
    },
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无修改权限`,
          showClose: true,
        });
      }
    },
    init() {
      this.isLoading = true;
      this.requiredList = [];
      customerSettings().then((res) => {
        res.result.map((item) => {
          if (!item.isCollection) {
            this.requiredList.push(item);
          }
        });
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      });
    },
    cancel() {
      this.init();
    },

    changeSelectedScope(item) {
      if (this.permissions["System.CustomerSettings.Update"]) {
        this.changeClaims(item, item.value);
      } else {
        this.$message.warning({
          message: `您暂无更新客源设置权限`,
          showClose: true,
        });
      }
    },
    changeClaims(setting, selectedScope) {
      let data = [];
      this.requiredList.map((item) => {
        data.push({
          name: item.name,
          value: item.value,
          forceToSet: false,
          isCollection: false,
        });
      });
      let settings = {
        settings: data,
      };
      updateCustomerSettings(
        this.$store.getters.generateUpdateSettingsParams,
        settings
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.init();
        this.isEditSetting = false;
      });
    },
    submit() {
      this.requiredSetting = deepCopy(this.requiredList);
      //console.log("提交接口");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.customer-basic {
  padding: 20px;
  background: #fff;
  .title {
    margin-bottom: 20px;
    font-size: 15px;
  } 
  .clear{
    clear:both;
  }
  .check-box {
    //  @include flex(row,center);
    float: left;
    width: 200px;
    margin-bottom: 15px;
  }
  .btn-group{
    padding-top: 20px;
  }
}
</style>